import PropTypes from '../../_util/vue-types';
const triggerType = PropTypes.oneOf(['hover', 'focus', 'click', 'contextmenu']);
export default () => ({
  trigger: PropTypes.oneOfType([triggerType, PropTypes.arrayOf(triggerType)]).def('hover'),
  canOpen: PropTypes.bool.def(true), //可展开
  defaultOpen: PropTypes.bool.def(true), //默认展开
  canHide: PropTypes.bool.def(false), //可隐藏
  defaultHide: PropTypes.bool.def(false), //默认不隐藏
  direction: PropTypes.oneOf([
    'horizontal', // 水平
    'vertical', // 竖直
  ]).def('vertical'),
  placement: PropTypes.oneOf([
    'topLeft', // 顶部靠左
    'topRight', // 顶部靠右
    'bottomLeft', // 底部靠左
    'bottomRight', // 底部靠右
  ]).def('bottomRight'),
  className: PropTypes.string,
  type: PropTypes.string,
  offsetBottom: PropTypes.string,
  offsetTop: PropTypes.string,
  fixed: PropTypes.bool.def(false), // 固定
  title: PropTypes.string.def('快捷应用'), // 固定
  icon: PropTypes.string.def('FCshouyeshezhi'), // 图标
});
